import { Controller } from "@hotwired/stimulus";

// Hotel search field's "how many rooms, how many guests per room" section.
// Mirrors the show/hide behavior the old jQuery version had: the room-count
// select governs how many of the (always-rendered, up to 4) room blocks are
// visible, and each room's own children-count select governs how many of
// that room's child-age sub-selects show.
export default class extends Controller {
  static targets = ["roomCount", "room", "childrenSelect", "childAgesPanel", "childAge"];

  connect() {
    this.updateRoomCount();
    this.childrenSelectTargets.forEach((select) => this.updateChildAges(select));
  }

  updateRoomCount() {
    const count = parseInt(this.roomCountTarget.value, 10) || 1;
    this.roomTargets.forEach((room, index) => {
      room.classList.toggle("hidden", index >= count);
    });
  }

  onChildrenChange(event) {
    this.updateChildAges(event.target);
  }

  updateChildAges(select) {
    const roomIndex = parseInt(select.dataset.roomIndex, 10);
    const count = parseInt(select.value, 10) || 0;
    const panel = this.childAgesPanelTargets.find((el) => parseInt(el.dataset.roomIndex, 10) === roomIndex);
    if (!panel) return;

    panel.classList.toggle("hidden", count === 0);
    this.childAgeTargets
      .filter((el) => parseInt(el.dataset.roomIndex, 10) === roomIndex)
      .forEach((el) => {
        el.classList.toggle("hidden", parseInt(el.dataset.childIndex, 10) > count);
      });
  }
}
